import { useFormatting } from "@msys/ui";
import { Description as DescriptionIcon } from "@mui/icons-material";
import { Paper, Stack, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import type { PendingDocShareProjectDraft } from "./projectDraft.js";

interface Props {
  quoteSummary: PendingDocShareProjectDraft["quoteSummary"];
}

// The incoming material quote being accepted, shown above the project fields.
export function SharedQuoteSummaryCard({ quoteSummary }: Props) {
  const { t } = useTranslate(["ProjectCreate"]);
  const { getFormattedDate, getFormattedPrice } = useFormatting();

  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: "action.hover",
        borderLeft: 4,
        borderColor: "primary.main",
        px: 2,
        py: 1.5,
      }}
    >
      <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
        <DescriptionIcon color="primary" />
        <Stack sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography variant="overline" sx={{ color: "text.secondary" }}>
            {t("Incoming material quote", { ns: "ProjectCreate" })}
          </Typography>
          <Typography variant="subtitle2" sx={{ overflowWrap: "anywhere" }}>
            {quoteSummary.title}
          </Typography>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            {[
              quoteSummary.sharingOrganisationTitle,
              t("No. {number}", {
                ns: "ProjectCreate",
                number: quoteSummary.number,
              }),
              getFormattedDate(quoteSummary.date),
            ].join(" · ")}
          </Typography>
        </Stack>
        <Typography
          variant="subtitle1"
          data-testid="quote-net-total"
          sx={{ fontWeight: 500, whiteSpace: "nowrap" }}
        >
          {getFormattedPrice(quoteSummary.netTotal)}
        </Typography>
      </Stack>
    </Paper>
  );
}
